import React, { useEffect, useState } from "react";
import Slider from "react-slick"; // React Slick
import { useParams } from "react-router-dom"; // useParams 가져오기
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../firebase"; // Firestore 초기화

import Loading from '../../Loading';

import styleClasses from '../css/mobile/PositionSkill.module.scss';

// 레벨에 따른 퍼센티지 매핑
const levelToPercentage = {
  Beginner: 25,
  Intermediate: 50,
  Advanced: 75,
  Expert: 100,
};

const PositionSkill = () => {
  const { id: musicianId }        = useParams(); // URL에서 musicianId 가져오기
  const [positions, setPositions] = useState([]); // 포지션 데이터 상태
  const [isLoading, setIsLoading] = useState(true); // 로딩 상태
  const [prevButton1, setPrevButton1] = useState(styleClasses.hidden);
  const [nextButton1, setNextButton1] = useState(styleClasses.visible);
  const [prevButton2, setPrevButton2] = useState(styleClasses.hidden);
  const [nextButton2, setNextButton2] = useState(styleClasses.visible);
  const [prevButton3, setPrevButton3] = useState(styleClasses.hidden);
  const [nextButton3, setNextButton3] = useState(styleClasses.visible);
  const [currentSkill1, setCurrentSkill1] = useState(1);
  const [currentSkill2, setCurrentSkill2] = useState(1);
  const [currentSkill3, setCurrentSkill3] = useState(1);
  
  // Firestore에서 데이터 가져오기
  const fetchPositions = async (musicianId) => {
    try {
      // 1. positions 컬렉션의 문서 이름 가져오기
      const positionsRef = collection(db, "musicians", musicianId, "positions");
      const positionsSnapshot = await getDocs(positionsRef);

      const positionNames = positionsSnapshot.docs.map((doc) => doc.id); // 문서 ID 리스트

      const fetchedPositions = [];

      // 2. 각 position의 skills 가져오기
      for (const position of positionNames) {
        const skillsRef = collection(
          db,
          "musicians",
          musicianId,
          "positions",
          position,
          "skills"
        );
        const skillsSnapshot = await getDocs(skillsRef);

        const skills = skillsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        fetchedPositions.push({
          position: position.charAt(0).toUpperCase() + position.slice(1), // 첫 글자 대문자화
          skills,
        });
      }

      setPositions(fetchedPositions);
    } catch (error) {
      console.error("Error fetching positions:", error);
    } finally {
      setIsLoading(false); // 로딩 완료
    }
  };

  useEffect(() => {
    if (musicianId) {
      fetchPositions(musicianId); // 뮤지션 ID로 데이터 가져오기
    }
  }, [musicianId]);

  // 슬라이더 설정
  const CustomPrevArrow1 = ({ className, style, onClick }) => (
    <button className={`${ styleClasses.skillsArrow } ${ styleClasses.prev } ${ prevButton1 }`} onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
        <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path>
      </svg>
    </button>
  );
  const CustomNextArrow1 = ({ className, style, onClick }) => (
    <button className={`${ styleClasses.skillsArrow } ${ styleClasses.next } ${ nextButton1 }`} onClick={ onClick }>
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
        <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
      </svg>
    </button>
  );

  const sliderSettings1 = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <CustomPrevArrow1 />,
    nextArrow: <CustomNextArrow1 />,
    className: styleClasses.customSlick,
    afterChange: (index) => {
      let skill1  = positions[0]['skills'] ?? 0;
      
      if (index === 0)   setPrevButton1(styleClasses.hidden);
      else               setPrevButton1(styleClasses.visible);
      
      if (index === skill1.length - 1)  setNextButton1(styleClasses.hidden);
      else                              setNextButton1(styleClasses.visible);

      setCurrentSkill1(index + 1);
    }
  };

  const CustomPrevArrow2 = ({ className, style, onClick }) => (
    <button className={`${ styleClasses.skillsArrow } ${ styleClasses.prev } ${ prevButton2 }`} onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
        <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path>
      </svg>
    </button>
  );
  const CustomNextArrow2 = ({ className, style, onClick }) => (
    <button className={`${ styleClasses.skillsArrow } ${ styleClasses.next } ${ nextButton2 }`} onClick={ onClick }>
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
        <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
      </svg>
    </button>
  );

  const sliderSettings2 = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <CustomPrevArrow2 />,
    nextArrow: <CustomNextArrow2 />,
    className: styleClasses.customSlick,
    afterChange: (index) => {
      let skill2  = positions[1]['skills'] ?? 0;
      
      if (index === 0)   setPrevButton2(styleClasses.hidden);
      else               setPrevButton2(styleClasses.visible);
      
      if (index === skill2.length - 1)  setNextButton2(styleClasses.hidden);
      else                              setNextButton2(styleClasses.visible);

      setCurrentSkill2(index + 1);
    }
  };

  const CustomPrevArrow3 = ({ className, style, onClick }) => (
    <button className={`${ styleClasses.skillsArrow } ${ styleClasses.prev } ${ prevButton3 }`} onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
        <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path>
      </svg>
    </button>
  );
  const CustomNextArrow3 = ({ className, style, onClick }) => (
    <button className={`${ styleClasses.skillsArrow } ${ styleClasses.next } ${ nextButton3 }`} onClick={ onClick }>
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
        <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
      </svg>
    </button>
  );

  const sliderSettings3 = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <CustomPrevArrow3 />,
    nextArrow: <CustomNextArrow3 />,
    className: styleClasses.customSlick,
    afterChange: (index) => {
      let skill3  = positions[2]['skills'] ?? 0;
      
      if (index === 0)   setPrevButton3(styleClasses.hidden);
      else               setPrevButton3(styleClasses.visible);
      
      if (index === skill3.length - 1)  setNextButton3(styleClasses.hidden);
      else                              setNextButton3(styleClasses.visible);
      setCurrentSkill3(index + 1);
    }
  };

  const skillsComponent = (skills) => {
    return (
      skills.map((skill) => (
        <div key={ skill.id } className={ styleClasses.skillCard }>
          <h4 className={ styleClasses.skillName }>{ skill.name }</h4>
          <a href={ skill.link } target="_blank" rel="noopener noreferrer">
            <img src={ skill.icon } alt={ skill.name } className={ styleClasses.skillIcon } />
            <span className={ styleClasses.playIcon }>▶</span> {/* 재생 아이콘 */}
          </a>
          {skill.description && (<p className={ styleClasses.skillDescription }>{ skill.description }</p>)}
          <div className={ styleClasses.skillLevelBar }>
            <div className={ styleClasses.skillBarFill } style={{ width: `${levelToPercentage[skill.level]}%` }}></div>
          </div>
          <span className={ styleClasses.skillLevel }>{ skill.level } ({levelToPercentage[skill.level]}%)</span>
        </div>
      ))
    );
  }

  return (
    isLoading
    ?
    <Loading />
    :
    <div className={ styleClasses.positionSkill }>
      <div className={ styleClasses.gridContainer }>
        {
          positions.map((position, index) => (
            <div key={ position.position } className={ styleClasses.positionSection }>
              <h3 className={ styleClasses.positionTitle }>
                { position.position }
                <p><span>{ index === 0 ? currentSkill1 : index === 1 ? currentSkill2 : index === 2 ? currentSkill3 : 1 }</span> / { (position.skills).length }</p>
              </h3>
              <div className={ styleClasses.skillsGrid }>
                {
                    index === 0 ? <Slider {...sliderSettings1}>{ skillsComponent(position.skills) }</Slider>
                  : index === 1 ? <Slider {...sliderSettings2}>{ skillsComponent(position.skills) }</Slider>
                  : index === 2 ? <Slider {...sliderSettings3}>{ skillsComponent(position.skills) }</Slider>
                  : null
                }
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default PositionSkill;
